(function () {
    "use strict";

    angular
        .module("iMatApp")
        .directive("blurOnEnter", blurOnEnterDirective);

    blurOnEnterDirective.$inject = [];

    function blurOnEnterDirective() {
        var directive = {
            restrict: "A",
            link: link
        };
        return directive;

        function link(scope, elem, attrs, ngModel) {

            elem.on("keydown keypress", function (event) {
                if (event.which === 13) {
                    event.target.blur();
                    event.preventDefault();
                }
            });
            
            scope.$on("$destroy", function () {
                elem.off("keydown keypress");
            });
        }
    }
})();